import React, { useState, useCallback } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import 'moment/locale/ko';
import styled from 'styled-components';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Sector,
  Cell,
} from 'recharts';
import CustomTable from '../../components/CustomTable';
interface DataItem {
  name: string;
  value: number;
}

const SalesHotel = () => {
  const [tabType, setTabType] = useState<string>('time');
  const [selectType, setSelectType] = useState<number>(0);
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#000'];

  const data: DataItem[] = [
    { name: '아메리카노 A', value: 400 },
    { name: '아메리카노 B', value: 300 },
    { name: '아메리카노 C', value: 300 },
    { name: '아메리카노 D', value: 200 },
    { name: '아메리카노 E', value: 200 },
  ];
  const hotelList: any = [
    {
      hotel_name: '노크호텔01',
      sales_count: 160,
      price: 2145000,
      percent: 20,
    },
    {
      hotel_name: '노크호텔02',
      sales_count: 120,
      price: 1764000,
      percent: 17,
    },
    {
      hotel_name: '노크호텔03',
      sales_count: 100,
      price: 1290000,
      percent: 14,
    },
    {
      hotel_name: '노크호텔04',
      sales_count: 77,
      price: 874400,
      percent: 10,
    },
    {
      hotel_name: '노크호텔05',
      sales_count: 42,
      price: 500000,
      percent: 7,
    },
  ];
  const datas = [
    {
      name: '0시',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: '3시',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: '6시',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: '12시',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: '15시',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: '18시',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: '21시',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  function ProductSales() {
    const [activeIndex, setActiveIndex] = useState<any>(null);

    const onPieEnter = useCallback((_: any, index: number) => {
      setActiveIndex(index);
    }, []);
    const renderActiveShape = (props: any) => {
      const RADIAN = Math.PI / 180;
      const {
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
        percent,
        value,
        name,
      } = props;
      const sin = Math.sin(-RADIAN * midAngle);
      const cos = Math.cos(-RADIAN * midAngle);
      const sx = cx + (outerRadius + 5) * cos;
      const sy = cy + (outerRadius + 5) * sin;
      const mx = cx + (outerRadius + 10) * cos;
      const my = cy + (outerRadius + 10) * sin;
      const ex = mx + (cos >= 0 ? 1 : -1) * 11;
      const ey = my;
      const textAnchor = cos >= 0 ? 'start' : 'end';

      return (
        <g >
          <text x={cx} y={cy} dy={5} textAnchor="middle" fill={fill} style={{display:window.innerWidth < 900 ?'none':'block'}}>
            {payload.name}
          </text>
          <Sector
            cx={cx}
            cy={cy}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            startAngle={startAngle}
            endAngle={endAngle}
            fill={fill}
          />
          <Sector
            cx={cx}
            cy={cy}
            startAngle={startAngle}
            endAngle={endAngle}
            innerRadius={outerRadius + 2}
            outerRadius={outerRadius + 6}
            fill={fill}
          />
          <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
          <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 4}
            y={ey}
            textAnchor={textAnchor}
            fontSize={'12px'}
            width={'100%'}
            fill="#333">{`${name}`}</text>
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 5}
            y={ey}
            dy={18}
            textAnchor={textAnchor}
            fill="#999"
            fontSize={'12px'}>
            {`(${(percent * 50).toFixed(2)}%)`}
          </text>
        </g>
      );
    };
    return (
      <div>
        <div className="chartWrap">
          <div className="bestTitle">
            <div className="badge">TOP1</div>
            <h2>노트호텔1</h2>
            <p>총 160건</p>
          </div>
          <div className="pieChartWrap">
            <ResponsiveContainer
              width={'100%'}
              height={'100%'}
              aspect={(window.innerWidth < 900 ? 1.5 : 1.0) / 1.0}
              style={{ flex: 1 }}>
              <PieChart onMouseEnter={onPieEnter} >
                <Pie
                  data={data}
                  cx={window.innerWidth < 900 ? '50%' : '50%'}
                  cy={window.innerWidth < 900 ? '50%' : '40%'}
                  innerRadius={'55%'}
                  outerRadius={'70%'}
                  fill="#8884d8"
                  paddingAngle={3}
                  dataKey="value"
                  onMouseEnter={onPieEnter}
                  activeIndex={activeIndex}
                  activeShape={(props: any) => renderActiveShape(props)}>
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="chartListWrap">
              <div className="chartList">
                <p>2</p>
                <p>{hotelList[1].hotel_name}</p>
                <p>{hotelList[1].sales_count}건</p>
                <p>{hotelList[1].price.toLocaleString()}원</p>
              </div>
              <div className="chartList">
                <p>3</p>
                <p>{hotelList[2].hotel_name}</p>
                <p>{hotelList[2].sales_count}건</p>
                <p>{hotelList[2].price.toLocaleString()}원</p>
              </div>
              <div className="chartList">
                <p>4</p>
                <p>{hotelList[3].hotel_name}</p>
                <p>{hotelList[3].sales_count}건</p>
                <p>{hotelList[3].price.toLocaleString()}원</p>
              </div>
              <div className="chartList">
                <p>5</p>
                <p>{hotelList[4].hotel_name}</p>
                <p>{hotelList[4].sales_count}건</p>
                <p>{hotelList[4].price.toLocaleString()}원</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // CustomTable
  const tableHeader = ['순서', '호텔명', '건수', '결제금액', '비중'];
  const renderTableItem = () => {
    return (
      <>
        {hotelList.length > 0 ? (
          hotelList.map((item: any, index: number) => (
            <div key={index} className="listContent">
              <p>{index + 1}</p>
              <p>{item.hotel_name}</p>
              <p>{item.sales_count}건</p>
              <p>{item.price.toLocaleString()}원</p>
              <p>{item.percent}%</p>
            </div>
          ))
        ) : (
          <p>조회된 날짜에 결제 내역이 없습니다.</p>
        )}
      </>
    );
  };

  return (
    <Style>
      <div className="contentContainer">
        <div className="content">
          <ProductSales />
        </div>
        <div className="chartWrap">
          <h1>호텔별 매출 순위</h1>
          <CustomTable tableHeader={tableHeader} renderTableItem={renderTableItem} />
        </div>
      </div>
    </Style>
  );
};

export default SalesHotel;

const Style = styled.div`
  /* contentContainer */
  .contentContainer:nth-child(1) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    padding-bottom: 19px;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0;
  }
  .contentContainer:nth-child(3) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  /* TabWrap */
  .TabWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .tabBox {
    flex: 1;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #979797;
    cursor: pointer;
  }
  .tabBox.active {
    color: #4dd2ae;
  }

  /* header */
  .header {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  /* selectBoxWrap */
  .selectBoxWrap {
    display: flex;
    align-items: center;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #fff;
      font-size: 16px;
      color: #979797;
      padding: 12px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }
  /* excelDownload */
  .excelDownload {
    margin-left: auto;
    margin-top: 20px;
    padding: 6px 20px;
    background: #f7f7f7;
    border: 1px solid #979797;
    border-radius: 5px;

    p {
      font-size: 14px;
      font-weight: 600;
      color: #555;
    }
  }

  /* 시간대별 */
  .mainTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 50px 0;
    gap: 5px;

    .item {
      flex: 1;
      text-align: center;

      .title {
        display: inline-block;
        margin-bottom: 20px;
        padding: 6px 12px;
        border: 1px solid #e5e5e5;
        border-radius: 50px;
        font-size: 16px;
        font-weight: 600;
        color: #979797;
      }
      .title.pointer {
        color: #ff7e7e;
      }
      .time {
        margin-bottom: 6px;
        font-size: 28px;
        font-weight: 600;
        color: #555;
      }
      .count {
        font-size: 16px;
        font-weight: 500;
        color: #cecece;
      }
    }
  }

  /* chartWrap */
  .chartWrap {
    margin-bottom: 10%;
    h1 {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 600;
      color: #555;
    }
  }
  .pieChartWrap {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .chartListWrap {
    width: 100%;
    flex: 1;

    .chartList {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      p {
        font-size: 16px;
        font-weight: 500;
        color: #555;
        text-align: center;
      }
      p:nth-child(1) {
        flex: 0 0 5%;
        width: 5%;
      }
      p:nth-child(2) {
        flex: 0 0 40%;
        width: 40%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p:nth-child(3) {
        flex: 0 0 15%;
        width: 15%;
      }
      p:nth-child(4) {
        flex: 0 0 35%;
        width: 35%;
        text-align: right;
      }
    }
  }

  .bestTitle {
    display: inline-block;
    text-align: center;

    .badge {
      display: inline-block;
      padding: 2px 10px;
      border: 1px solid #cecece;
      font-size: 12px;
      font-weight: 600;
      color: #ff7e7e;
      border-radius: 50px;
    }
    h2 {
      margin: 10px 0 6px 0;
      font-size: 28px;
      font-weight: 600;
      color: #555;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      color: #cecece;
    }
  }

  /* listWrap */
  .listTitle h2,
  .listContent p {
    text-align: center;
  }
  .listTitle h2:nth-child(1),
  .listContent p:nth-child(1) {
    flex: 0 0 8%;
    width: 8%;
    text-align: center;
  }
  .listTitle h2:nth-child(2),
  .listContent p:nth-child(2) {
    flex: 0 0 30%;
    width: 30%;
    text-align: center;
  }
  .listTitle h2:nth-child(3),
  .listContent p:nth-child(3) {
    flex: 0 0 19%;
    width: 19%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .listTitle h2:nth-child(4),
  .listContent p:nth-child(4) {
    flex: 0 0 28%;
    width: 28%;
  }
  .listTitle h2:nth-child(5),
  .listContent p:nth-child(5) {
    flex: 0 0 15%;
    width: 15%;
  }

  @media (max-width: 900px) {
    .pieChartWrap {
      flex-direction: column;
    }
    
  }
`;
